import { Component } from '@angular/core';
import { Sidenav } from "../sidenav/sidenav";

@Component({
  selector: 'app-body',
  imports: [Sidenav],
  templateUrl: './body.html',
  styleUrl: './body.css'
})
export class Body {

}
